export const TID = {
  // Header
  headerLogo: "header-logo",
  navHome: "nav-home",
  navServices: "nav-services",
  navQuote: "nav-quote",
  navContact: "nav-contact",
  langSwitcher: "lang-switcher",
  langOption: (code) => `lang-option-${code}`,
  mobileMenuToggle: "mobile-menu-toggle",
  mobileMenu: "mobile-menu",
  callTopButton: "call-top-button",

  // Hero
  heroSection: "hero-section",
  heroTitle: "hero-title",
  heroCtaQuote: "hero-cta-quote",
  heroCtaCall: "hero-cta-call",

  // About / Services / Why
  aboutSection: "about-section",
  servicesSection: "services-section",
  transportCard: "transport-card",
  cleaningCard: "cleaning-card",
  whySection: "why-section",
  whyItem: (i) => `why-item-${i}`,

  // Quote form
  quoteSection: "quote-section",
  quoteForm: "quote-form",
  quoteName: "quote-name-input",
  quotePhone: "quote-phone-input",
  quoteEmail: "quote-email-input",
  quoteService: "quote-service-select",
  quoteMessage: "quote-message-input",
  quoteSubmit: "quote-submit-button",
  quoteSuccess: "quote-success-banner",
  quoteError: "quote-error-banner",

  // Contact
  contactSection: "contact-section",
  contactPhone1: "contact-phone-1",
  contactPhone2: "contact-phone-2",
  contactEmail: "contact-email",
  contactAddress: "contact-address",
  contactMap: "contact-map",

  // Footer
  footer: "site-footer",
  footerImprint: "footer-imprint-link",
  footerPrivacy: "footer-privacy-link",
};
